import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface Group {
    value?: string;
    viewValue?: string;
    latLon?: { latitude: number, longitude: number };
    sensors?: any[];
    latLonList?: any[];
}

@Injectable({ providedIn: 'root' })
export class OverallStatsComService {

    private statsWeeklyPrivate$: BehaviorSubject<any[]> = new BehaviorSubject([])

    constructor() { }

    public setOverallStats(groups: any[]) {
        return this.statsWeeklyPrivate$.next(groups)
    }

    public get getOverallStats(): Observable<any[]> {
        return this.statsWeeklyPrivate$.asObservable()
    }
}

